const initState = {
    // NOTE: This belongs to the data on the Order Detail page 20191024:Alevale
    ODReturnItems: [],
    ODInvoices: [],
    ODOrder: undefined,
    returnReasons: [],
    returnItems: [],
    isReturning: false,
    wishlistId: undefined,
    returnsCartCount: 0,
    returnPackages: [],
    order: undefined,
    shipTos: [],
    totalPrice: {},
    showSecondContact: false,
    checkoutOptions: {
        'checkoutOptions': {
            'shipmentDetails': {},
            'shipTos': [{}],
            'billTos': [{}],
            'payers': [{}],
            'supplier': {},
            'replacePoRequired': false,
            'poPendingRequired': false,
            'isDistributor': false,
            'dropShipEnabled': false,
            'validateDuplicatePO': false,
            'soldToUpdateApplicable': false,
            'costCenterUpdateApplicable': false,
            'freightChargeApplicable': false,
            'isSSPOptional': false
        }
    }
};

export const SET_RETURN_ITEMS = 'SET_RETURN_ITEMS';
export const SET_RETURN_WISHLIST = 'SET_RETURN_WISHLIST';
export const SET_RETURN_CART_COUNT = 'SET_RETURN_CART_COUNT';
export const SET_ORDER_DETAIL_ORDER = 'SET_ORDER_DETAIL_ORDER';
export const SET_ORDER = 'SET_ORDER';
export const SET_SHIP_TOS = 'SET_SHIP_TOS';
export const SET_RETURN_PACKAGES = 'SET_RETURN_PACKAGES';
export const SET_RETURN_REASONS = 'SET_RETURN_REASONS';
export const SET_ORDER_DETAIL_RETURN_ITEMS = 'SET_ORDER_DETAIL_RETURN_ITEMS';
export const SET_ORDER_DETAIL_INVOICES = 'SET_ORDER_DETAIL_INVOICES';
export const SET_SECOND_CONTACT = 'SET_SECOND_CONTACT';
export const SET_ORDER_TOTAL_PRICE = 'SET_ORDER_TOTAL_PRICE';

export const setReturnItems = (data) => ({ type: SET_RETURN_ITEMS, payload: data });
export const setReturnsWishlist = (data) => ({ type: SET_RETURN_WISHLIST, payload: data });
export const setReturnsCartCount = (data) => ({ type: SET_RETURN_CART_COUNT, payload: data });
export const setOrderDetailsPageOrder = (data) => ({ type: SET_ORDER_DETAIL_ORDER, payload: data });
export const setOrder = (data) => ({ type: SET_ORDER, payload: data });
export const setShipTos = (data) => ({ type: SET_SHIP_TOS, payload: data });
export const setSecondContact = (data) => ({ type: SET_SECOND_CONTACT, payload: data });
export const setReturnsPackages = (data) => ({ type: SET_RETURN_PACKAGES, payload: data });
export const setReturnsReasons = (data) => ({ type: SET_RETURN_REASONS, payload: data });
export const setODReturnItems = (data) => ({ type: SET_ORDER_DETAIL_RETURN_ITEMS, payload: data });
export const setODReturnInvoices = (data) => ({ type: SET_ORDER_DETAIL_INVOICES, payload: data });
export const setOrderTotalPrice = (data) => ({ type: SET_ORDER_TOTAL_PRICE, payload: data });


export default (state = initState, action) => {
    switch (action.type) {
        case SET_RETURN_ITEMS:
            return { ...state, returnItems: action.payload };
        case SET_RETURN_WISHLIST:
            return { ...state, wishlistId: action.payload };
        case SET_RETURN_CART_COUNT:
            return { ...state, returnsCartCount: action.payload };
        case SET_ORDER_DETAIL_ORDER:
            return { ...state, ODOrder: action.payload };
        case SET_ORDER:
            return { ...state, order: action.payload };
        case SET_SECOND_CONTACT:
            return { ...state, showSecondContact: action.payload };
        case SET_SHIP_TOS:
            return { ...state, shipTos: action.payload };
        case SET_RETURN_PACKAGES:
            return { ...state, returnPackages: action.payload };
        case SET_RETURN_REASONS:
            return { ...state, returnReasons: action.payload };
        case SET_ORDER_DETAIL_RETURN_ITEMS:
            return { ...state, ODReturnItems: action.payload };
        case SET_ORDER_DETAIL_INVOICES:
            return { ...state, ODInvoices: action.payload };
        case SET_ORDER_TOTAL_PRICE:
            return { ...state, totalPrice: action.payload };
        default:
            return state
    }
}
